import apiClient from "@/utils/cb-client";
import {postPaymentActionsApiConfig} from "@/utils/post-payment-actions-config";

export default class ApiRequestBuilder {
  static attachBrowserHeaders(headers) {
    headers["origin"] = window.location.origin;
    headers["refer"] = window.location.href;
    headers["cookie"] = document.cookie;
    if (apiClient.getLocale()) {
      headers["locale"] = apiClient.getLocale();
    }
  }

  static buildHeaders(configKey) {
    const config = postPaymentActionsApiConfig[configKey];
    const headers = apiClient.getHeadersForApi(config.apiGroup, config.apiAction);
    this.attachBrowserHeaders(headers);

    if (config.cbSource) headers["CbSource"] = config.cbSource;
    if (config.contentType && !headers["Content-Type"]) {
      headers["Content-Type"] = config.contentType;
    }
    return headers;
  }

  static generateRequest(configKey, payload, pathParams = {}, hpToken, paymentIntentID, extraFields = {}) {
    const apiAction = apiClient.getActionForApi(
      postPaymentActionsApiConfig[configKey].apiGroup,
      postPaymentActionsApiConfig[configKey].apiAction
    );
    if (!apiAction.ignore_locale && apiClient.getLocale()) {
      payload.locale = apiClient.getLocale();
    }
    return {
      endpoint: apiClient.getEndpointForApi(
        postPaymentActionsApiConfig[configKey].apiGroup,
        postPaymentActionsApiConfig[configKey].apiAction,
        pathParams
      ),
      payload: JSON.stringify(payload),
      headers: JSON.stringify(this.buildHeaders(configKey)),
      hosted_page_token: hpToken,
      external_payment_intent_id: paymentIntentID,
      ...extraFields
    };
  }

  static requestApiClientBulkPayload(thisBulkRequest, hpToken, paymentIntentID, postPaymentActionsFlow) {
    if (postPaymentActionsFlow) {
      const bulkRequest = this.generateRequest("checkout_for_items", thisBulkRequest.toJSON(), {}, hpToken, paymentIntentID);
      return apiClient.generic.post_payment({hp_token: hpToken}, bulkRequest);
    }
    return apiClient.generic.bulk({hp_token: hpToken}, thisBulkRequest.toJSON());
  }

  static requestApiClientGiftBulkPayload(thisBulkRequest, hpToken, paymentIntentID, postPaymentActionsFlow) {
    if (postPaymentActionsFlow) {
      const bulkRequest = this.generateRequest("checkout_for_items", thisBulkRequest.toJSON(), {}, hpToken, paymentIntentID);
      return apiClient.generic.post_payment({}, bulkRequest);
    }
    return apiClient.generic.bulk({}, thisBulkRequest.toJSON());
  }

  static generateSubscriptionRequest(payload, hpToken, paymentIntentID) {
    return this.generateRequest(
      "checkout",
      payload,
      {hp_token: hpToken},
      hpToken,
      paymentIntentID
    );
  }

  static generatePortalPIRequest(payload, params, paymentIntentID, sspToken) {
    return this.generateRequest(
      "portalPI",
      payload,
      {hp_token: params.hp_token},
      null,
      paymentIntentID,
      {ssp_token: sspToken}
    );
  }

  static generateCollectNowRequest(payload, params, paymentIntentID, hpToken) {
    return this.generateRequest(
      "collectNow",
      payload,
      {id: params.id},
      hpToken,
      paymentIntentID
    );
  }
}
